// ProductOne component - Converted from components/ProductOne.vue
// Products section with progress bars
import React from 'react';
import productImg from '../assets/images/resources/product.png';

const ProductOne: React.FC = () => {
  return (
    <section className="product-one">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6">
            <div className="product_img wow fadeInUp" data-wow-delay="200ms">
              <img src={productImg} alt="Agriculture Product" />
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="growing_product wow fadeInUp" data-wow-delay="300ms">
              <div className="block-title text-left">
                <p>PRODUITS FRAIS</p>
                <h3>CULTURE D&apos;OLIVES</h3>
              </div>
              <div className="growing_product_text">
                <p>
                  Leaders Agro Elite excelle dans la culture d&apos;olives de qualité supérieure,
                  offrant une huile d&apos;olive extra vierge et des olives de table savoureuses.
                  Nos pratiques agricoles durables garantissent des produits frais et authentiques.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductOne;
